import { AsyncPipe, NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { UaService } from '@ecm/consumer';
import { EcmRouterModule, Link, LinkService, RouterService, TrackingData } from '@ecm/router';

import { UniverseEnum } from '../../../../business/api/dashboard/universeEnum';
import { ProtectedHouseContractViewModel } from '../../../../business/model/crossroads/contracts-options/protectedHouse-contract.view-model';
import { ContractsViewModel } from '../../../../business/model/crossroads/contracts.view-model';
import { TrackedPage } from '../../../../business/model/tracking/trackedPage.enum';
import { AbstractComponent } from '../../../shared/abstract.component';
import { CrossroadsUtils } from '../../utils/crossroads.utils';

@Component({
    selector: 'ecm-protected-house-bill',
    templateUrl: 'protected-house-bill.html',
    styleUrls: ['protected-house-bill.css'],
    standalone: true,
    imports: [NgClass, AsyncPipe, EcmRouterModule],
})
export class ProtectedHouseBillComponent extends AbstractComponent implements OnInit {
    @Input()
    public viewModel: ContractsViewModel;

    @Input()
    public hideBorder: boolean;

    @Input()
    public universe: UniverseEnum;

    public mixedSoshPicto = 'assets/dashboard/images/mini-logo-sosh.png';
    public mixedOrangePicto = 'assets/dashboard/images/mini-logo-orange.png';

    public protectedHouseContractViewModel: ProtectedHouseContractViewModel;

    public icon: string = null;

    /**
     * Generated link to protected house web site
     * @type {Observable<string>}
     */
    public openProtectedHouseLink: Observable<string> = null;

    /**
     * GA tracking area
     * @type {string}
     */
    private readonly trackingArea: string = 'care_selectionfacture_factures';

    public constructor(
        protected uaService: UaService,
        protected routerService: RouterService,
        private readonly translate: TranslateService,
        private readonly linkService: LinkService,
    ) {
        super(uaService, routerService);
        translate.use('fr');
    }

    public ngOnInit(): void {
        super.ngOnInit();
        if (this.viewModel.contract) {
            this.protectedHouseContractViewModel = this.viewModel.contract as ProtectedHouseContractViewModel;
        }
        if (this.universe === UniverseEnum.MIXED) {
            this.icon =
                CrossroadsUtils.getIconBrand(this.universe, this.viewModel, this.protectedHouseContractViewModel) ===
                UniverseEnum.SOSH
                    ? this.mixedSoshPicto
                    : this.mixedOrangePicto;
        }
    }

    /**
     * Open button link for protected house web site
     * @param {Link} link
     */
    public openProtectedHouseContract(link: Link): void {
        this.translate.get('dashboard.contractsAndOptions.multiContract').subscribe((multiContract: any) => {
            this.linkService.openLink(
                link,
                Object.assign(new TrackingData(), {
                    tmsTracking: {
                        trackedPage: TrackedPage.bills,
                        trackingArea: this.trackingArea,
                        trackingName: multiContract['button'],
                    },
                }),
                null,
                null,
                true,
            );
        });
    }
}
